import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';

type ProviderValue = {
  partnerName: string;
  setPartnerName: (name: string) => void;
  clipHash: string;
  setClipHash: (hash: string) => void;
};

const PartnerContentContext = createContext<ProviderValue>({
  partnerName: '',
  setPartnerName: (name: string) => {},
  clipHash: '',
  setClipHash: (hash: string) => {},
});

export const usePartnerContent = () => useContext(PartnerContentContext);

export const PartnerContentProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { search } = useLocation();
  const integrationData = queryString.parse(decodeURIComponent(search));

  const [partnerName, setPartnerName] = useState<string>(
    String(integrationData.integrationName)
  );
  const [clipHash, setClipHash] = useState<string>(
    String(integrationData.clipHash)
  );

  return (
    <PartnerContentContext.Provider
      value={{
        partnerName,
        setPartnerName,
        clipHash,
        setClipHash,
      }}
    >
      {children}
    </PartnerContentContext.Provider>
  );
};
